<!-- 作业反馈 -->
<template>
	<div>
		<div class="index">
			<div class="title">
				<div class="span1">
					<span>{{ $route.name }}</span>
				</div>
			</div>

			<div>
				<div class="Homeboxtop_nav_tab">
					<span
						v-for="(item, index) in tabList"
						:class="['res-tab', { active: item.name === tabName }]"
						:key="index"
						@click="tabClick(item)"
					>
						{{ item.name }}
					</span>
				</div>
				<el-form :inline="true" :model="queryParams" label-width="45px">
					<el-form-item label="学科:">
						<el-select v-model="queryParams.subjectId" clearable placeholder="请选择" class="label">
							<el-option
								v-for="item in SubjectList"
								:key="item.subjectId"
								:label="item.subjectName"
								:value="item.subjectId"
							>
							</el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="教师:">
						<el-select
							v-model="queryParams.teacherId"
							clearable
							filterable
							placeholder="请选择"
							class="label"
						>
							<el-option
								v-for="item in teacherList"
								:key="item.teacherId"
								:label="item.teacherName"
								:value="item.teacherId"
							>
							</el-option>
						</el-select>
					</el-form-item>

					<el-button type="primary" size="small" @click="searchFun()" class="findBtn"
						>查询</el-button
					>
				</el-form>

				<!-- 校内教师 -->
				<div class="table">
					<el-table :data="tableData" style="width: 100%" border>
						<el-table-column prop="username" label="教师" align="center"> </el-table-column>
						<el-table-column prop="homeworkDate" label="学科" align="center"> </el-table-column>
						<el-table-column prop="subjectName" label="登记作业次数" align="center">
						</el-table-column>
						<el-table-column prop="classname" label="作业驳回次数" align="center">
						</el-table-column>
						<el-table-column prop="finishDuration" label="作业驳回率" align="center">
						</el-table-column>
						<el-table-column prop="" label="操作" align="center">
							<template slot-scope="scope">
								<el-button type="text" @click="toDetail(scope)">查看</el-button>
							</template>
						</el-table-column>
					</el-table>
					<!-- 分页组件 -->
					<div class="pagination">
						<el-pagination
							background
							:current-page="pageNum"
							:page-sizes="[10, 20, 50, 100]"
							:page-size="pageSize"
							:total="totalPage"
							layout="total,prev, pager, next,jumper,sizes"
							@size-change="sizeChangeHandle"
							@current-change="currentChangeHandle"
						></el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { getHwFeedbackList } from "@/api/school/index.js";
	import dayjs from "dayjs";
	// import to from "@/utils/await-to";
	// import reqTip from "@/utils/requestTip";
	import localForage from "localforage";

	export default {
		components: {},
		data() {
			return {
				tableData: [],
				teacherList: [],
				pageNum: 1,
				pageSize: 10,
				totalPage: 0,
				queryParams: {
					classId: "",
					subjectId: "",
					homeworkDate: "",
					difficulty: "",
					feedbackDate: "",
				},
				tabList: [{ name: "本周" }, { name: "本月" }, { name: "本学期" }, { name: "本年度" }],
				tabName: "本周",
			};
		},
		watch: {},
		activated() {
			this.getTableData();
		},
		created() {
			this.getCommonList();
		},
		methods: {
			tabClick(item) {
				this.tabName = item.name;
			},
			async getCommonList() {
				this.teacherList = await localForage.getItem("teacherList");
			},
			// 获取作业反馈列表
			async getTableData() {
				let ss = sessionStorage;
				let params = {
					loginPlatformCode: ss.loginPlatformCode,
					platformCode: ss.platformCode,
					usessionid: ss.usessionid,
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					classId: this.queryParams.classId,
					homeworkDate:
						(this.queryParams.homeworkDate &&
							dayjs(this.queryParams.homeworkDate).format("YYYY-MM-DD")) ||
						"",
					subjectId: this.queryParams.subjectId,
					difficulty: this.queryParams.difficulty,
					feedbackDate:
						(this.queryParams.feedbackDate &&
							dayjs(this.queryParams.feedbackDate).format("YYYY-MM-DD")) ||
						"",
				};
				const res = await getHwFeedbackList(params);
				console.log("作业反馈列表--", res);
				let list = res.list;
				list.forEach((item) => {
					item.homeworkDate = dayjs(item.homeworkDate).format("YYYY-MM-DD");
					item.feedbackDate = dayjs(item.feedbackDate).format("YYYY-MM-DD HH:mm");
					item.estimateDuration = item.estimateDuration + "分钟";
					item.finishDuration = item.finishDuration + "分钟";
				});
				this.tableData = list;
				this.totalPage = res.total;
			},
			// 查看作业反馈详情
			toDetail(scope) {
				console.log("scope----1223", scope.row);
				this.$router.push({
					path: "/task/analysis/quality/qualityDetail",
					// query: {},
				});
			},
			//新增后刷新作业反馈列表
			refreshTableData() {
				this.getTableData();
			},

			searchFun() {
				this.pageNum = 1;
				this.getTableData();
			},
			sizeChangeHandle(val) {
				this.pageSize = val;
				this.getTableData();
			},
			currentChangeHandle(val) {
				this.pageNum = val;
				this.getTableData();
			},
		},
	};
</script>
<style lang="less" scoped>
	.index {
		width: 100%;
		padding: 0px 30px 30px 30px;
		.title {
			height: 68px;
			line-height: 80px;
			border-bottom: 1px solid #eaeaea;
			margin-bottom: 20px;
			display: flex;
			justify-content: space-between;
			.span1 {
				font-family: "PingFang SC Bold";
				font-weight: 500;
				font-size: 20px;
				text-align: left;
				color: #333;
			}
		}
		.findBtn {
			float: right;
			width: 80px;
			height: 32px;
			border-radius: 3px;
			background: #4991e1;
			font-size: 14px;
			margin-top: 5px;
		}
		.hwContent {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			> div:first-child img {
				width: 18px;
				height: 18px;
				margin-top: 6px;
				margin-right: 5px;
			}
			> div:last-child {
				text-align: left;
			}
		}
		.show-hover {
			cursor: pointer;
		}
		// .Homeboxtop_nav_tab span {
		// 	display: inline-block;
		// 	margin-bottom: 10px;
		// 	font-weight: 400;
		// 	font-size: 15px;
		// 	margin-right: 30px;
		// 	cursor: pointer;
		// 	/* padding-bottom: 15px; */
		// }
		// .Homeboxtop_nav_tab .active {
		// 	color: #4991e1;
		// 	border-bottom: 3px solid #4991e1;
		// }
		.res-tab {
			padding-bottom: 15px;
		}
		::v-deep .el-form-item__label {
			color: #333;
		}
		::v-deep .el-form .el-input__inner {
			width: 120px;
			height: 32px;
			border-radius: 3px;
			background: #fff;
			border: 1px solid #ddd;
		}

		::v-deep .el-table__header tr th {
			background: #f7f7f7;
			box-shadow: 0px 1px 0px #eaeaea;
		}
		::v-deep .el-table {
			color: #333;
		}

		::v-deep .el-date-editor .el-range-separator {
			line-height: 22px;
		}
		::v-deep .el-table thead th.el-table__cell {
			padding: 15 0.5px 0;
			font-weight: normal;
			font-size: 14px;
			color: #7a8da2;
			background: #fafafa;
		}
		::v-deep .el-table tbody td.el-table__cell {
			padding: 18.5px 0;
		}

		.pagination {
			text-align: center;
			margin-top: 30px;
		}
		.waitPreview {
			color: #4b83f7;
		}
		.inPreview {
			color: orange;
		}
		.passed {
			color: #50b173;
		}
		.rejected {
			color: #f74b4b;
		}
		.classFrame {
			::v-deep .el-input__inner {
				width: 135px;
			}
		}
		::v-deep .el-date-editor.el-input {
			width: 150px;
		}
		::v-deep .el-date-editor .el-input__inner {
			width: 150px !important;
		}
		::v-deep .el-icon-arrow-left {
			margin-top: 0;
		}
		::v-deep .el-icon-arrow-right {
			margin-top: 0;
		}
	}
</style>
